/**
 * Created by daniel on 25/04/17.
 */


/**
 * A content definition category
 * @typedef {string} ContentCategoryName
 *
 */

/**
 * An object containing valid content category types
 * @type {Object.<ContentCategoryName>}
 */
export const CONTENT_DEFINITION_CATEGORIES = (() => {
  /**
   * @type {ContentCategoryName}
   */
  let STRUCTURAL_COMPONENTS = "Structural Components";
  /**
   * @type {ContentCategoryName}
   */
  let STANDARD_COMPONENTS = "Standard Components";
  /**
   * @type {ContentCategoryName}
   */
  let DYNAMIC_COMPONENT = "Dynamic Components";
  /**
   * @type {ContentCategoryName}
   */
  let CUSTOM_COMPONENTS = "Custom Components";
  
  return {
    STRUCTURAL_COMPONENTS,
    STANDARD_COMPONENTS,
    DYNAMIC_COMPONENT,
    CUSTOM_COMPONENTS,
  }
})();

/**
 * @typedef {Object} TemplateColor
 * @property {string} name - Name of the colour
 * @property {string} color - Hexadecimal representation of this colour. Note US spelling.
 *
 */

/**
 * An array containing valid colours used in the template
 * @type {Array.<TemplateColor>}
 */
export const COLORS = (() => {

  return [
    {
      name: "abiMidnightBlue",
      color: "#230052",
    },
    {
      name: "abiPurple",
      color: "#7f58a5",
    },
    {
      name: "abiBlue",
      color: "#6e9bb0",
    },
    {
      name: "abiRed",
      color: "#ce0c4e",
    },
    {
      name: "abiOrange",
      color: "#f26334",
    },
    {
      name: "abiGreen",
      color: "#a8ad2c",
    },
    {
      name: "black",
      color: "#231f20",
    },
    {
      name: "grey",
      color: "#939596",
    },
    {
      name: "aqua",
      color: "#53c0a5",
    },
    {
      name: "stone",
      color: "#c59872",
    },
    {
      name: "mauve",
      color: "#7f2c72",
    },
    {
      name: "yellow",
      color: "#fcb316",
    },
  ];
})();


/**
 * A content item definition
 * @typedef {Object} ContentDefinition
 *
 * @property {string} contentId
 * @property {string} contentIsRoot
 * @property {string} contentParentId
 * @property {string} contentOldParentId
 * @property {string} contentName
 * @property {string} contentContent
 * @property {boolean} contentHidden
 *
 * @property {string} configId
 * @property {string} configName
 * @property {string} configDescription
 * @property {ContentCategoryName} configCategory
 * @property {String} configPrimitive
 * @property {Array} configChildren
 *
 * @property {string} viewClass
 * @property {Object} viewAttributes
 * @property {Object} viewCss
 *
 * @property {string} styleWidth
 * @property {string} styleBackgroundColour
 * @property {string} styleTextColour
 * @property {string} styleTextAlignment
 *
 * @property {Array.<Object>} editorAllowedParents
 * @property {boolean} editorLocked
 * @property {boolean} editorSelectable
 * @property {boolean} editorDraggable
 * @property {boolean} editorDragTarget
 * @property {boolean} editorHideable
 * @property {boolean} editorCloneable
 * @property {boolean} editorDeletable
 * @property {boolean} editorEditable
 * @property {boolean} editorSaveable
 *
 */

/**
 * A base definition to subclass in exported variants
 * @type {ContentDefinition}
 */
export const BASE_DEFINITION = {
  styleWidth: "",
  styleHeight: "",
  stylePadding: "",
  styleBackgroundColour: "",
  styleTextColour: "",
  styleTextAlignment: "",
  
  contentHidden: false,
  contentId: "",
  contentIsRoot: false,
  contentParentId: "",
  contentOldParentId: "",
  contentName: "",
  contentContent: "",
  
  configId: "BASE_DEFINITION",
  configName: "Base definition",
  configDescription: "This is the base definition. It should be used a template for other definitions.",
  configCategory: CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
  configPrimitive: "",
  configChildren: "",
  
  viewClass: "",
  viewAttributes: {},
  viewCss: {},
  
  
  editorAllowedParents: [],
  editorLocked: false,
  editorSelectable: true,
  editorDraggable: true,
  editorDragTarget: true,
  editorHideable: true,
  editorCloneable: true,
  editorDeletable: true,
  editorEditable: true,
  editorSaveable: true,
};


// WEBPACK FOOTER //
// ./src/App/Editor/constants.js